/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const purchaseOrders = sqliteTable('purchase_orders', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  po_number: text('po_number'),
  po_date: text('po_date'),
  supplier_id: text('supplier_id'),
  supplier_name: text('supplier_name'),
  amounts_are: text('amounts_are'),
  notes: text('notes'),
  status: text('status'),
  status_executor: text('status_executor'),
  total_amount: real('total_amount'),
  created_by: text('created_by'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
